import React, { Component } from 'react';
import { setCurrentView } from 'core/utils';
import {defaultTemplate} from 'core/hoc';
import PropTypes from 'prop-types';

class PatientPreviewTabs extends Component {
  render() {
    const routes = [{
        title: 'General',
        state: 'master.app.main.patient.preview.general',
    }, {
        title: 'Orders',
        state: 'master.app.main.patient.preview.orders',
    } , {
        title: 'Templates',
        state: 'master.app.main.patient.preview.templates',
    }];

    const links = routes.map((route) => {
      if(route.authorization && !this.props.rootStore.authStore.hasPermission(route.authorization)){
        return null;
      }else{
        return (
          <a key={route.title} className={"tabs__item" + (this.props.patientPreviewTabsStore.selectedRoute == route.state ? ' active': '')} 
          onClick={() => this.props.patientPreviewTabsStore.navigateTo(route.state)}>{route.title}</a> 
        );
      }
    });

    return (
      <React.Fragment>
        <div className="tabs__wrapper tabs--fullwidth is-sml">
          <div className="tabs">
              {links}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

PatientPreviewTabs.propTypes = {
  rootStore: PropTypes.any,
  patientPreviewTabsStore: PropTypes.object
};

export default setCurrentView(
  (rootStore, props) => new PatientPreviewTabsStore(rootStore, props),
  'patientPreviewTabsStore'
)(defaultTemplate(PatientPreviewTabs));

class PatientPreviewTabsStore {
  constructor(rootStore, props) {
    this.rootStore = rootStore;
    this.queryParams = props.queryParams;
    this.selectedRoute = props.route;
    this.navigateTo = (route) => {
        this.rootStore.routerStore.setTransitionData({
            navigationTitle: this.queryParams.firstName + ' ' + this.queryParams.lastName
        });
        this.rootStore.routerStore.goTo(route, this.queryParams);
    };
  }
}
